import { render, staticRenderFns } from "./CardUserSibling.vue?vue&type=template&id=93ef4fb2"
import script from "./CardUserSibling.vue?vue&type=script&lang=js"
export * from "./CardUserSibling.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports